import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { KeycloakService, UserData } from 'src/app/authentication/keycloak.service';
import { ShortcutLinksService, Shortcut } from '../../services/shortcut-links.service';
import { Router } from '@angular/router';
import { SharedModule } from '../../shared.module';
import { SecurityService, UserProfile } from 'src/app/security/security.service';
import { DocumentService } from 'src/app/documents/documents.service';
import { UserLocalStoreService } from '../../services/user-local-store.service';
import { MaterialImageViewerComponent } from 'src/app/shared/components/material-image-viewer/material-image-viewer';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-user-management-panel',
  templateUrl: './user-management-panel.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MaterialImageViewerComponent,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,]
})
export class UserManagementPanelComponent implements OnInit {

  thumbnail: any;
  shortcut: Shortcut[] = [];
  userData?: UserData;
  user: UserProfile | undefined;
  isSignedIn!: boolean;
  isSignedOut!: boolean;
  _settings: Shortcut[] = [];

  constructor(
    private _keycloakService: KeycloakService,
    private _shortcutLinksService: ShortcutLinksService,
    private _documentsService: DocumentService,
    private _userLocalStorage: UserLocalStoreService,
    private _securityService: SecurityService,
    private _router: Router) {
  }

  async loadUserData() {
    this.isSignedIn = true;
    this.isSignedOut = false;
    this.userData = this._keycloakService.getUser();
    const profile = await this._securityService.getUserProfile();
    if (profile) {
      this.user = profile.profile;
      if (this.user?.profileImageId) {
        this.downloadProfileImage();
      } else {
        this.thumbnail = '/assets/icons/main-logo/user.png';
      }
    } else {
      this.thumbnail = '/assets/icons/main-logo/user.png';
    }
  }

  addOrRemoveShortcut(name: string, link: string) {
    const a: Shortcut = {
      name,
      link,
    };
    if (this._settings.filter(t => t.name === name || t.link === link).length > 0) {
      this._settings = this._settings.filter(t => !(t.name === name || t.link === link));
    } else {
      this._settings.push(a);
    }
    this._shortcutLinksService.publishShortcuts(this._settings);
  }

  isChecked(label: string) {
    return this._settings.filter(s => s.name === label).length > 0;
  }

  ngOnInit() {
    this.userData = this._keycloakService.getUser();
    const links = this._userLocalStorage.get<Shortcut[]>('ShortCut');
    if (links) {
      this._settings = links;
    }

    this._shortcutLinksService.shortcutPublished.subscribe(sh => {
      this.shortcut = sh.filter(s => s.link);
    });

    this.loadUserData();

    return undefined;
  }

  signOut() {
    this._keycloakService.logout();
  }
  navigateTo(l: string) {
    this._router.navigate([l]);
  }

  downloadProfileImage() {
    this._documentsService.download(this.user?.profileImageId || '').subscribe(b => {
      const reader = new FileReader();
      reader.readAsDataURL(b.body);
      reader.onload = () => {
        this.thumbnail = reader.result;
      };
    });
  }

}
